import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MailCheck } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { useBranding } from "../lib/branding";

export default function ForgotPassword() {
  const branding = useBranding();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || "Something went wrong");
    }
    setLoading(false);
  };

  return (
    <div className="auth-split" data-testid="forgot-shell">
      <div className="auth-split-left">
        <div className="auth-split-logo">
          <img src={branding.logo_data_url || "/pragma-login-logo-v4.png"} alt="Pragma" />
        </div>
        <div className="auth-split-form-wrap">
          {sent ? (
            <>
              <h1 className="auth-split-h1" data-testid="forgot-sent-heading">Check your inbox</h1>
              <p className="auth-split-sub">
                <MailCheck size={14} style={{ display: "inline", verticalAlign: -2, marginRight: 6, color: "var(--pg-accent-deep)" }} />
                If an account exists for <strong>{email}</strong>, we've sent a password reset link.
                It expires in 30 minutes.
              </p>
              <div className="auth-split-actions">
                <Link to="/login" className="auth-split-submit" data-testid="forgot-back-to-login">
                  Back to sign in <ArrowRight strokeWidth={2.2} />
                </Link>
              </div>
            </>
          ) : (
            <>
              <h1 className="auth-split-h1" data-testid="forgot-heading">Reset your password</h1>
              <p className="auth-split-sub">Enter the email tied to your Pragma account.</p>
              <form onSubmit={submit} data-testid="forgot-form">
                <input
                  type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="auth-split-input" placeholder="Email address"
                  data-testid="forgot-email" required autoComplete="email"
                />
                {err && <div className="auth-split-error" data-testid="forgot-error">{err}</div>}
                <div className="auth-split-actions">
                  <Link to="/login" className="auth-split-secondary" data-testid="forgot-back-link">
                    Back to sign in
                  </Link>
                  <button type="submit" className="auth-split-submit" disabled={loading} data-testid="forgot-submit">
                    {loading ? "Sending…" : "Send reset link"}
                    <ArrowRight strokeWidth={2.2} />
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
      <div className="auth-split-right">
        <h2 className="auth-split-right-h1">
          {branding.heading_line_1}<br /><span className="accent">{branding.heading_line_2}</span>
        </h2>
      </div>
    </div>
  );
}
